
import { Inject, Injectable, DOCUMENT } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsApiLoaderService {
  private loadPromise?: Promise<typeof google>;

  constructor(@Inject(DOCUMENT) private document: Document) {}

  load(): Promise<typeof google> {
    if (typeof google !== 'undefined' && google.maps) {
      return Promise.resolve(google);
    }

    if (!this.loadPromise) {
      this.loadPromise = new Promise((resolve, reject) => {
        const existingScript = this.document.getElementById('google-maps-script') as HTMLScriptElement | null;

        if (existingScript) {
          existingScript.addEventListener('load', () => resolve(google), { once: true });
          existingScript.addEventListener('error', () => reject(new Error('Google Maps failed to load.')), { once: true });
          return;
        }

        const script = this.document.createElement('script');
        script.id = 'google-maps-script';
        script.async = true;
        script.defer = true;
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBajkLHFeKGPwkvXBqq_GUb9CWv_nyar6g&libraries=places&language=de';
        script.onload = () => resolve(google);
        script.onerror = () => reject(new Error('Google Maps failed to load.'));
        this.document.head.appendChild(script);
      });
    }

    return this.loadPromise;
  }
}
